import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fabfeab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-grow-1" }
const _hoisted_2 = { class: "table table-hover table-v2" }
const _hoisted_3 = {
  key: 0,
  class: "result-info-container"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "alert alert-warning mt-2"
}
const _hoisted_8 = { class: "col-12 wrapper bg-light p-3 mt-3 mb-2" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "text-nowrap pe-2 align-top" }
const _hoisted_11 = { class: "text-nowrap pe-2 align-top" }
const _hoisted_12 = { class: "text-nowrap pe-2 align-top" }
const _hoisted_13 = { class: "text-nowrap pe-2 align-top" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_base_modal = _resolveComponent("base-modal")!
  const _component_BasePagination = _resolveComponent("BasePagination")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('backgroundTasks'),
        mb: 4,
        "show-refresh-button": "",
        onRefresh: _ctx.reloadContent,
        "back-route": {name: _ctx.backRoute}
      }, null, 8, ["title", "onRefresh", "back-route"]),
      _createVNode(_component_AlertError2, {
        error: _ctx.pageUI.getError()
      }, null, 8, ["error"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('timestamp')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('description')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('document')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('status')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('result')), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAsyncHandlings, (asyncHandling) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: asyncHandling.polling_id
              }, [
                _createElementVNode("td", null, _toDisplayString(asyncHandling.created), 1),
                _createElementVNode("td", null, _toDisplayString(asyncHandling.description), 1),
                _createElementVNode("td", null, _toDisplayString(asyncHandling.document_meta?.filename), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["status-badge", _ctx.getStatusClass(asyncHandling.status.code)])
                  }, _toDisplayString(asyncHandling.status.description), 3)
                ]),
                _createElementVNode("td", null, [
                  (_ctx.hasFullResultInfo(asyncHandling))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", {
                          innerHTML: asyncHandling.short_result_info,
                          class: "short-result"
                        }, null, 8, _hoisted_4),
                        _createVNode(_component_base_modal_button, {
                          "modal-id": 'resultModal-' + asyncHandling.polling_id,
                          class: "btn btn-sm btn-outline-primary mt-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('viewAllResults')), 1)
                          ]),
                          _: 2
                        }, 1032, ["modal-id"]),
                        _createVNode(_component_base_modal, {
                          "modal-id": 'resultModal-' + asyncHandling.polling_id,
                          title: _ctx.$t('allResults'),
                          "dialog-classes": "modal-lg"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              innerHTML: asyncHandling.full_result_info
                            }, null, 8, _hoisted_5)
                          ]),
                          _: 2
                        }, 1032, ["modal-id", "title"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        innerHTML: asyncHandling.short_result_info
                      }, null, 8, _hoisted_6))
                ])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_BasePagination, {
          "pagination-data": _ctx.asyncHandlings.paging_metadata,
          "n-pagination-items": 7,
          "show-page-items-count": "",
          class: "d-flex flex-column me-3",
          onChangePage: _ctx.onChangePageNumber
        }, null, 8, ["pagination-data", "onChangePage"]),
        (_ctx.shouldAutoRefresh())
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('importProcessing')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('asyncHandlingText1')), 1),
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$t('asyncHandlingText2')) + ": ", 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t('asyncHandlingText3')), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$t('asyncHandlingText4')) + ": ", 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t('asyncHandlingText5')), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$t('asyncHandlingText6')) + ": ", 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t('asyncHandlingText7')), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.$t('asyncHandlingText8')) + ": ", 1),
              _createElementVNode("td", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('asyncHandlingText9')), 1),
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('asyncHandlingText10')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}